export * from './RouteParams'
export * from './types'
export const EmptyFn = () => {} // eslint-disable-line @typescript-eslint/no-empty-function
export const EmptyPromiseFn = () => Promise.resolve()

export interface BaseLegacyPageProps {
  isMultiLocation?: boolean
}
